<div class="request-create-form">
  <div class="wrapper-breadcrumbs">
    <scc-dsm3-nav-breadcrumbs [items$]="breadcrumbsItems$"></scc-dsm3-nav-breadcrumbs>
  </div>

  <div class="content">
    <div class="sidebar">
      <div class="sidebar-row">
        <app-request-type-sidebar [title]="title" [subTitle]="subTitle"> </app-request-type-sidebar>
      </div>
    </div>

    <div class="form-content">
      <app-request-form [formTabData]="form" (clickBack)="back()"></app-request-form>
    </div>
  </div>
</div>
